import { Autocomplete, Avatar, Button, Checkbox, Chip, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, MenuList, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router';
import groupImg from "../../../assets/images/people.png"
import { useDispatch, useSelector } from 'react-redux';
import { chatActions } from '../../../redux/reducer/chatReducer';
import CreateGroup from './CreateGroup';
import { ChatType } from '../../../util/ChatUtils';
import { UserAPI } from '../../../api/UserAPI';
import SecondLoader from '../../../component/SecondLoader';
import InfiniteScroll from 'react-infinite-scroll-component';
import { debounce } from 'lodash';

const AddNewChat = ({ setIsUpdate, setAnchorEl }) => {
    const userInfo = useSelector((store) => store.user.userInfo);
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [formState, setFormState] = useState({ isGroup: false, isNext: false });
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [pageDetails, setPageDetails] = useState({ pageNumber: 0, pageSize: 30 });
    const [searchKey, setSearchKey] = useState('')
    const [hasMore, setHasMore] = useState(true);
    const [selectedIds, setSelectedIds] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);

    const handleInputValue = (user) => {

        if (formState.isNext) return;

        const idIndex = selectedIds.indexOf(user.userId);
        const newIds = [...selectedIds];
        const newUsers = [...selectedUsers];

        if (idIndex === -1) {
            // add
            newIds.push(user.userId);
            newUsers.push(user);
        } else {
            // remove
            newIds.splice(idIndex, 1);
            const userIndex = newUsers.findIndex(u => u.userId === user.userId);
            if (userIndex !== -1) newUsers.splice(userIndex, 1);
        }

        setSelectedIds(newIds);
        setSelectedUsers(newUsers);
    };
    const handleFormState = (isGroup, isNext) => {
        setFormState({ isGroup: isGroup, isNext: isNext });
    }

    const getUserNameById = (id) => {
        const findUser = selectedUsers.find((user) => user.userId === id);
        return `${findUser?.userFirstName || ''} ${findUser?.userLastName || ''}`
    }
    const getProfileImageById = (id) => {
        const findUser = selectedUsers.find((user) => user.userId === id);
        return findUser?.profileImage;
    }

    useEffect(() => {
        findChatUsers('');
    }, [])

    const findChatUsers = async (searchKey) => {
        try {
            setIsLoading(true)
            const response = await UserAPI.getUsersBYClubForChat(
                selectedClub.clubId,
                userInfo.userId,
                pageDetails.pageSize,
                pageDetails.pageNumber,
                searchKey
            );
            setUsers(response.Data);
            if (response.Data.length === 0) {
                setHasMore(false);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setIsLoading(false);
        }
    }
    const findMoreChatUsers = async () => {
        if (isLoading || !hasMore) return;

        const nextPage = pageDetails.pageNumber + 1;

        try {
            setIsLoading(true);

            const response = await UserAPI.getUsersBYClubForChat(
                selectedClub.clubId,
                userInfo.userId,
                pageDetails.pageSize,
                nextPage,
                searchKey
            );

            const newUsers = response.Data;

            setUsers(prev => {
                const merged = [...prev, ...newUsers];

                return Array.from(
                    new Map(merged.map(user => [user.userId, user])).values()
                );
            });

            setPageDetails(prev => ({
                ...prev,
                pageNumber: nextPage
            }));

            // 🔑 Important fix
            if (newUsers.length < pageDetails.pageSize) {
                setHasMore(false);
            }

        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    const onSearchDebounce = debounce((searchText) => {
        setPageDetails(prev => ({
            pageNumber: 0, // keep 0-based in state
            pageSize: prev.pageSize,
        }));
        findChatUsers(searchText ?? '');
        if(!searchText){
            setHasMore(true)
        }
    }, 400);

    return (
        <div style={{ width: 350, padding: 20, borderRadius: '20px', overflow: 'hidden' }}>
            {formState?.isGroup ?
                <div className='sm_add_user_in_group_con'>
                    <h2>New group</h2>
                    {/* <TextField className='sm_search_user_to_add_in_group' onChange={handleSearch} fullWidth size='small' label="Search name or email" variant='standard' /> */}
                    <Autocomplete
                        multiple
                        limitTags={3}
                        freeSolo
                        options={[]} // you can provide suggestions here
                        value={selectedIds}
                        disableClearable={true}
                        className="sm_search_user_to_add_in_group"
                        // onChange={(event, newValue) => setValues(newValue)}
                        renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <Chip
                                    key={option}
                                    variant="outlined"
                                    sx={{ background: 'var(--hoverColorBold)', fontWeight: 600 }}
                                    label={getUserNameById(option)}
                                    {...getTagProps({ index })}
                                    onDelete={() => handleInputValue(selectedUsers.find(u => u.userId === option))}
                                    avatar={<Avatar alt={getUserNameById(option)}
                                        src={`${import.meta.env.VITE_APP_BASE_URL}/user/user-profile-img/${getProfileImageById(option)}`} />}
                                />
                            ))
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                className='sm_search_user_to_add_in_group' onChange={(e) => {
                                    setSearchKey(e.target.value);
                                    onSearchDebounce(e.target.value);
                                }} fullWidth size='small' label="Search name or email" variant='standard'
                            />
                        )}
                    />
                    {formState.isNext ?
                        <CreateGroup clubId={selectedClub?.clubId} setIsUpdate={setIsUpdate} userInfo={userInfo} userIds={selectedIds} setAnchorEl={setAnchorEl} />
                        :
                        <>
                            {selectedIds?.length != 0 &&
                                <div className='sm_add_user_in_group_nav_buttons'>
                                    <Button variant='contained' onClick={() => handleFormState(true, true)}>Next</Button>
                                    <Button color='error' variant='outlined' onClick={() => setAnchorEl(null)}>Cancel</Button>
                                </div>}
                            <div id='chat_group_user_infine_scroll' style={{ overflow: 'scroll', height: '80dvh' }}>
                                <InfiniteScroll
                                    scrollableTarget='chat_group_user_infine_scroll'
                                    next={findMoreChatUsers}
                                    hasMore={hasMore}
                                    style={{ display: 'flex', flexDirection: 'column-reverse', gap: '10px' }}
                                    dataLength={users.length}
                                >
                                    <List>
                                        {
                                            users?.map((user) =>
                                                <ListItem
                                                    key={user.userId}
                                                    secondaryAction={
                                                        <Checkbox
                                                            className='sm_select_user_to_addin_group_checkbox'
                                                            edge="end"
                                                            checked={selectedIds.includes(user.userId)}
                                                            onClick={() => handleInputValue(user)}
                                                        // inputProps={{ 'aria-labelledby': labelId }}
                                                        />
                                                    }
                                                    disablePadding
                                                >
                                                    <ListItemButton onClick={() => handleInputValue(user)}>
                                                        <ListItemAvatar>
                                                            <Avatar
                                                                alt={`${user?.userFirstName}`}
                                                                src={`${import.meta.env.VITE_APP_BASE_URL}/user/user-profile-img/${user?.profileImage}`}
                                                            />
                                                        </ListItemAvatar>
                                                        <ListItemText primary={`${user?.userFirstName} ${user?.userLastName}`} />
                                                    </ListItemButton>
                                                </ListItem>
                                            )
                                        }
                                    </List>
                                </InfiniteScroll>
                            </div>

                        </>}


                </div>
                :
                <div className='sm_add_user_in_chat_con'>
                    <h2>New chat</h2>
                    <TextField fullWidth size='small' onChange={(e) => {
                        setSearchKey(e.target.value);
                        onSearchDebounce(e.target.value);
                    }} label="Search name or email" variant='standard' />
                    <div className='sm_add_user_in_chat_list' onClick={() => handleFormState(true, false)}>
                        <Avatar src={groupImg} />
                        <h3>New group</h3>
                    </div>
                    {isLoading ?
                        <SecondLoader />
                        : <div id='chat_user_infine_scroll' className='sm_add_user_list_con'>
                            <InfiniteScroll
                                scrollableTarget='chat_user_infine_scroll'
                                next={findMoreChatUsers}
                                hasMore={hasMore}
                                style={{ display: 'flex', flexDirection: 'column-reverse', gap: '10px' }}
                                dataLength={users.length}
                            >
                                {
                                    users?.map((user, index) =>
                                        <div key={index} onClick={() => {
                                            const chat = {
                                                chatType: ChatType.PRIVATE,
                                                privateChatImage: user.profileImage,
                                                privateChatName: `${user.userFirstName} ${user.userLastName}`,
                                                privateChatUserId: user.userId
                                            }
                                            dispatch(chatActions.setOpenChat(true));
                                            dispatch(chatActions.setCurrentChat(chat));
                                            navigate(`/chat/chat-body/null`, {
                                                state: {
                                                    currentChat: chat
                                                }
                                            })
                                            setAnchorEl(null);
                                        }} className='sm_add_user_in_chat_list'>
                                            <Avatar src={`${import.meta.env.VITE_APP_BASE_URL}/user/user-profile-img/${user.profileImage}`} />
                                            <h3>{user.userFirstName + " " + user.userLastName}</h3>
                                        </div>
                                    )
                                }
                            </InfiniteScroll>
                        </div>}
                </div>}

        </div>
    )
}

export default AddNewChat